"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerCalendarDefaultProps = exports.WEEKS_TO_SHOW = exports.FOCUS_OFFSET = exports.DISABLED_STRIKETHROUGH_WIDTH = exports.DISABLED_STRIKETHROUGH_HEIGHT = exports.DAYS_IN_WEEK = exports.DATE_MARKER_SIZE = exports.DATE_MARKER_COLOR = exports.CORNER_DATE_MARKER_SIZE = exports.CALENDAR_WRAPPER_PADDING = exports.CALENDAR_WRAPPER_MAX_WIDTH = exports.CALENDAR_WIDTH = exports.CALENDAR_ROW_GAP = exports.CALENDAR_HEIGHT = exports.CALENDAR_HEADER_ROW_HEIGHT = exports.CALENDAR_CELL_SIZE = void 0;
var DAYS_IN_WEEK = 7;
exports.DAYS_IN_WEEK = DAYS_IN_WEEK;
var WEEKS_TO_SHOW = 6;
exports.WEEKS_TO_SHOW = WEEKS_TO_SHOW;
var CALENDAR_CELL_SIZE = 40;
exports.CALENDAR_CELL_SIZE = CALENDAR_CELL_SIZE;
var CALENDAR_HEADER_ROW_HEIGHT = 30;
exports.CALENDAR_HEADER_ROW_HEIGHT = CALENDAR_HEADER_ROW_HEIGHT;
var CALENDAR_ROW_GAP = 8;
exports.CALENDAR_ROW_GAP = CALENDAR_ROW_GAP;
var CALENDAR_HEIGHT = CALENDAR_HEADER_ROW_HEIGHT + CALENDAR_CELL_SIZE * WEEKS_TO_SHOW + CALENDAR_ROW_GAP * (WEEKS_TO_SHOW - 1);
exports.CALENDAR_HEIGHT = CALENDAR_HEIGHT;
var CALENDAR_WIDTH = 7 * CALENDAR_CELL_SIZE;
exports.CALENDAR_WIDTH = CALENDAR_WIDTH;
var CALENDAR_WRAPPER_PADDING = 16;
exports.CALENDAR_WRAPPER_PADDING = CALENDAR_WRAPPER_PADDING;
var CALENDAR_WRAPPER_MAX_WIDTH = CALENDAR_WIDTH + 2 * CALENDAR_WRAPPER_PADDING + 34; // TODO adjust the max width to allow for the year picker

exports.CALENDAR_WRAPPER_MAX_WIDTH = CALENDAR_WRAPPER_MAX_WIDTH;
var FOCUS_OFFSET = 2;
exports.FOCUS_OFFSET = FOCUS_OFFSET;
var DISABLED_STRIKETHROUGH_WIDTH = CALENDAR_CELL_SIZE * 0.5;
exports.DISABLED_STRIKETHROUGH_WIDTH = DISABLED_STRIKETHROUGH_WIDTH;
var DISABLED_STRIKETHROUGH_HEIGHT = 2;
exports.DISABLED_STRIKETHROUGH_HEIGHT = DISABLED_STRIKETHROUGH_HEIGHT;
var DATE_MARKER_SIZE = 32;
exports.DATE_MARKER_SIZE = DATE_MARKER_SIZE;
var CORNER_DATE_MARKER_SIZE = 6;
exports.CORNER_DATE_MARKER_SIZE = CORNER_DATE_MARKER_SIZE;
var DATE_MARKER_COLOR = 'neutral70';
exports.DATE_MARKER_COLOR = DATE_MARKER_COLOR;
var datePickerCalendarDefaultProps = {
  yearPickerButtonAltText: 'Select a year.',
  yearPickerButtonDescribeText: 'Has a popup dialog, navigate using arrow keys.'
};
exports.datePickerCalendarDefaultProps = datePickerCalendarDefaultProps;